export const REQUEST_DASHBOARD = 'REQUEST_DASHBOARD';
export const REQUEST_DASHBOARD_SUCCESS = 'REQUEST_DASHBOARD_SUCCESS';
export const REQUEST_DASHBOARD_FAILURE = 'REQUEST_DASHBOARD_FAILURE';

export const REQUEST_MONTHLY_ORDER_DELIVERY = 'REQUEST_MONTHLY_ORDER_DELIVERY';
export const REQUEST_MONTHLY_ORDER_DELIVERY_SUCCESS = 'REQUEST_MONTHLY_ORDER_DELIVERY_SUCCESS';
export const REQUEST_MONTHLY_ORDER_DELIVERY_FAILURE = 'REQUEST_DASHBOARD_MONTHLY_ORDER_DELIVERY_FAILURE';

export const REQUEST_BILL_PAYMENT = 'REQUEST_BILL_PAYMENT';
export const REQUEST_BILL_PAYMENT_SUCCESS = 'REQUEST_BILL_PAYMENT_SUCCESS';
export const REQUEST_BILL_PAYMENT_FAILURE = 'REQUEST_BILL_PAYMENT_FAILURE';

export const REQUEST_DELIVERY = 'REQUEST_DELIVERY'
export const REQUEST_DELIVERY_SUCCESS = 'REQUEST_DELIVERY_SUCCESS'
export const REQUEST_DELIVERY_FAILURE = 'REQUEST_DELIVERY_FAILURE'

export const REQUEST_PAYMENT = 'REQUEST_PAYMENT'
export const REQUEST_PAYMENT_SUCCESS = 'REQUEST_PAYMENT_SUCCESS'
export const REQUEST_PAYMENT_FAILURE = 'REQUEST_PAYMENT_FAILURE'